<template>
  <Card class="company-card-details fullheight pos-relative" v-if="company">
    <div class="company-img pos-relative">
      <div class="company-cover-con pos-relative">
        <img v-if="company.cover_photo" class="company-cover centered clickable" :alt="company.name" :src="company.cover_photo" @click="handleTechProviderPage(company.slug)" />
        <img v-else class="company-cover centered clickable" src="~@/assets/images/default-cover-photo.jpg" alt="kromnix logo" width="100%" @click="handleTechProviderPage(company.slug)" />
        <div class="com-check" v-if="enableSelection">
          <Checkbox @on-change="handleOnSelect"></Checkbox>
        </div>
      </div>
      <div class="k-avatar logo-con">
        <Avatar v-if="company.logo" :src="company.logo" size="50"/>
        <img v-else src="~@/assets/images/logo/default-company-logo.png" alt="kromnix logo" width="100%" class="centered">
      </div>
    </div>
    <div class="company-info">
      <p class="title"><b>{{ company.name }}</b></p>
      <p>{{ company.tagline }}</p>
    </div>
    <div class="other-info padding-20">
      <Row justify="center" align="middle" :gutter="5">
        <i-col :xs="18" class="other-categories">
          <div class="company-categories" v-if="company.categories.length">
            <Avatar icon="logo-buffer" size="small" style="background-color:#b00101;margin-right:10px;"/>
            <span class="category-name ellipsis">{{company.categories[0]}}</span>
            <Tooltip max-width="300" placement="top" transfer transfer-class-name="black" v-if="company.categories.length > 1">
              <div class="more-category">+{{company.categories.length-1}}</div>
              <div slot="content">
                <p v-for="(cat, idx) in company.categories" :key="idx">
                  <span v-if="idx > 0"> {{ cat }} </span>
                </p>
              </div>
            </Tooltip>
          </div>
        </i-col>
        <i-col :xs="6" class="other-actions">
          <Tooltip placement="top" transfer transfer-class-name="black">
            <Icon type="md-eye" size="14" color="#fff" @click="handleQuickView" class="clickable"/>
            <div slot="content">
              Quick view
            </div>
          </Tooltip>
          <Tooltip placement="top" transfer transfer-class-name="black">
            <Icon type="ios-bookmark" size="14" color="#fff" style="margin-left:5px;" :class="(marked)?'marked':''" @click="handleMark(company.id, marked)" class="clickable"/>
            <div slot="content">
              Bookmark
            </div>
          </Tooltip>
        </i-col>
      </Row>
    </div>
    <CompanyDetail ref="CompanyDetail" />
  </Card>
</template>

<script>
import CompanyDetail from './CompanyDetail'
import { addBookmark, deleteBookmark } from '@/services/bookmarks'

export default {
  components: {
    CompanyDetail
  },

  props: {
    company: {
      type: Object,
      default: null
    },
    enableSelection: {
      type: Boolean,
      default: false
    },
    isSelectionFull: {
      type: Boolean,
      default: false
    },
    marked: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleQuickView () {
      this.$refs.CompanyDetail.openModal(this.company.slug)
    },

    handleOnSelect (val) {
      this.$emit('select', val)
    },

    addBookmark (data) {
      addBookmark(data).then(res => {
        this.$Message.success('Tech provider bookmarked successfully')
        this.marked = true
        this.$emit('reload')
      }).catch(err => {
        console.log('Failed to add book mark: ', err)
      })
    },

    deleteBookmark (companyId) {
      deleteBookmark(companyId).then(res => {
        this.$Message.success('Tech provider removed from bookmark successfully')
        this.marked = false
        this.$emit('reload')
      }).catch(err => {
        console.log('Failed to remove book mark: ', err)
      })
    },

    handleMark (companyId, isMarked) {
      if (localStorage.getItem('_id')) {
        if (isMarked) {
          this.deleteBookmark(companyId)
        } else {
          this.addBookmark({ bookmark: companyId })
        }
      } else {
        this.$router.push({
          name: 'buyer-login'
        })
      }
    },

    handleTechProviderPage (slug) {
      window.location = this.$router.resolve({
        name: 'company',
        params: {
          slug: slug
        },
        query: {}
      }).href
    }
  }
}
</script>

<style lang="scss" scoped>
.company-card-details {
  overflow: hidden;
  .company-img {
    .company-cover-con {
        height:130px;
        width: 100%;
        overflow: hidden;
        background:rgba(0,0,0,0.6);
        .company-cover {
          opacity: 0.5;
          width: 100%;
          &:hover {
            opacity: 0.2;
          }
        }
        .com-check {
          position: absolute;
          right: 4px;
          top: 4px;
          box-shadow: 0px 3px 6px #00000029;
          border-radius: 4px;
          padding: 3px 7px;
           label {
             margin-right: 0px;
           }
        }
    }
    .k-avatar.logo-con {
      width: 50px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      top: 70%;
      background: #ffffff;
    }
  }
  .company-info {
    padding: 20px;
    margin-top: 20px;
    margin-bottom: 65px;
  }
  .other-info {
    position: absolute;
    bottom: 0px;
    width: 100%;
  }
  .other-categories {
    .company-categories {
      display: flex;
      align-items: center;
      justify-content: left;
    }
    .category-icon {
      background: $primary;
      border-radius: 50%;
      overflow: hidden;
      height: 25px;
      width: 25px;
      text-align: center;
      margin-right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .more-category {
      border:1px solid $secondary;
      border-radius: 50%;
      overflow: hidden;
      height: 20px;
      width: 20px;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5px;
    }
  }
  .other-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .ivu-icon {
      background: $secondary;
      border-radius: 50%;
      overflow: hidden;
      padding: 5px;
      &.marked {
        background: $primary;
      }
    }
  }
}
</style>
<style lang="scss">
.company-card-details {
  .ivu-card-body {
    padding: 0px;
  }
}
</style>
